import React, { Component } from 'react';

class FriendZoneLanding extends Component {
     render(){
         return (
            <div id='landing'>
               <div className='text-center'>
                  <img src="img/under-construction.gif" width="700" height="400" class="under-construction-desktop" alt="" />{" "}
                  <div id="under-construction-mobile"><p>Under Construction</p></div>
               </div>
            </div>
         )
   }
}

export default FriendZoneLanding;
